module.exports = __webpack_public_path__ + "img/Trial day Icon - charcoal.d318c9c0.svg";